import {createSelector} from "reselect";
import {State} from "../../../reducers";

const adminPeriodicalState = (state: State) => state.adminPeriodical;
const adminPublicationState = (state: State) => state.adminPublication;
export const currentAdminSelectedPeriodicalSelector = createSelector(adminPeriodicalState, state => state.currentSelectedAdminPeriodical);
export const currentAdminSelectedPeriodicalPlanSelector = createSelector(adminPeriodicalState, state => state.currentSelectedAdminPeriodicalPlan);
export const currentAdminSelectedPeriodicalDirtySelector = createSelector(adminPeriodicalState, state => state.dirty);
export const currentAdminSelectedPublicationAdminDirtySelector = createSelector(adminPublicationState, state => state.dirty);
